import React, { useRef } from 'react';
import styled from 'styled-components';

const ContainerWrapper = styled.div`
  background-color: rgb(51, 51, 51);
  color: rgb(255, 255, 255);
  padding: 0.5rem;
`;

// for future use
// eslint-disable-next-line no-unused-vars
const MarqueeMessageWrapper = styled.div`
  display: inline-block;
  padding-left: 100%;
  animation: marquee 15s linear infinite;
  @keyframes marquee {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(-100%, 0);
    }
  }
`;

const NormalMessageWrapper = styled.div`
  text-align: center;
`;

const MultiLineMessageWrapper = styled.div`
  text-align: left;
  overflow: auto;
  padding: 0 0.5rem;
`;

const Warning = ({ message, showMessage }) => {
  const messageDiv = useRef();

  // return the width of the given text of given font in pixels.
  const getTextWidth = (text, font) => {
    const canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement('canvas'));
    const context = canvas.getContext('2d');
    context.font = font;
    const metrics = context.measureText(text);
    return metrics.width;
  };

  // determine if div tag can display the whole text
  const areaAccommodatesText = () => {
    let divWidth = 0;
    let textLength = 0;
    if (messageDiv && messageDiv.current) {
      const font = getComputedStyle(messageDiv.current).font;
      // only if width value contains number, values have meaning.
      if (/\d/.test(getComputedStyle(messageDiv.current).width)) {
        divWidth = Number(getComputedStyle(messageDiv.current).width.match(/\d+/)[0]);
        textLength = getTextWidth(message, font);
      }
    }
    return divWidth > textLength;
  };

  if (!showMessage) return <div />;

  return (
    <div style={{ overflow: 'visible' }} ref={messageDiv}>
      {!messageDiv.current ? (
        <div />
      ) : (
        <ContainerWrapper>
          {areaAccommodatesText() ? (
            <NormalMessageWrapper>{message}</NormalMessageWrapper>
          ) : (
            <MultiLineMessageWrapper>{message}</MultiLineMessageWrapper>
          )}
        </ContainerWrapper>
      )}
    </div>
  );
};

export default Warning;



// WEBPACK FOOTER //
// ./src/components/ChatPanel/Warning/index.js